/**
 * Build a DocumentFragment from a static template string.
 * Use only with hard-coded markup — never interpolate user input.
 * For dynamic data, build with createElement + textContent.
 */
export function frag(markup: string): DocumentFragment {
  return document.createRange().createContextualFragment(markup);
}

/** Type-safe createElement with optional class and text content. */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options: { class?: string; text?: string; attrs?: Record<string, string> } = {}
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (options.class) node.className = options.class;
  if (options.text != null) node.textContent = options.text;
  if (options.attrs) for (const [k, v] of Object.entries(options.attrs)) node.setAttribute(k, v);
  return node;
}
